import { useDrag, useDrop } from 'react-dnd'
import variables from '../../styles/variables'
import InstantGridRow, { InstantGridRowProps } from './InstantGridRow'
import { beginDragRow, dropOnRow, endDragRow, ORDER_DND_TYPE } from './instantGridDnd'

type InstantGridDroppableRowProps<T> = InstantGridRowProps<T>

function InstantGridDroppableRow<T>(props: InstantGridDroppableRowProps<T>) {
  const { row, id, index, onDragEnd, setRef: incomingSetRef, ...restProps } = props

  const [, connectDragSource] = useDrag(
    () => ({
      type: ORDER_DND_TYPE,
      item: () => beginDragRow({ id, index }),
      end: (_item, monitor) => endDragRow({ id, index, onDragEnd }, row, monitor.getDropResult())
    }),
    [id, index, row, onDragEnd]
  )

  const [{ isOver, item }, connectDropTarget] = useDrop(
    () => ({
      accept: ORDER_DND_TYPE,
      drop: (_item, monitor) => dropOnRow({ id, index }, monitor.didDrop()),
      collect: (monitor) => ({ isOver: monitor.isOver(), item: monitor.getItem<{ index: number }>() })
    }),
    [id, index]
  )

  const borderStyle = `2px solid ${variables.newColors.primary}`

  const setRef = (el: any) => {
    incomingSetRef?.(el)
    connectDragSource(connectDropTarget(el))
  }

  const dragIndex = item?.index || 0
  const dropIndex = index || 0

  return (
    <InstantGridRow
      style={{
        borderTop: isOver && dragIndex > dropIndex ? borderStyle : '',
        borderBottom: isOver && dropIndex > dragIndex ? borderStyle : ''
      }}
      setRef={setRef}
      isDragEnabled={true}
      row={row}
      id={id}
      index={index}
      onDragEnd={onDragEnd}
      {...restProps}
    />
  )
}

export default InstantGridDroppableRow
